import React from "react";

import SearchPlayer from "../components/SearchPlayer";

export default function Players() {
  return (
    <>
      <SearchPlayer />
    </>
  );
}
